import menuScreenshot1 from "@me-team/common/src/images/modules/menu-screenshot_1.jpg";
import menuScreenshot2 from "@me-team/common/src/images/modules/menu-screenshot_2.png";
import menuScreenshot3 from "@me-team/common/src/images/modules/menu-screenshot_3.png";
import menuScreenshot4 from "@me-team/common/src/images/modules/menu-screenshot_4.jpg";
import menuScreenshot5 from "@me-team/common/src/images/modules/menu-screenshot_5.jpg";
import menuScreenshot6 from "@me-team/common/src/images/modules/menu-screenshot_6.jpg";

export interface MenuItem {
    text: string;
    subItems?: string[];
}

export interface MenuModuleDetail {
    title: string;
    items?: MenuItem[];
    text?: string;
    image: string;
    bgClass: string;
    reverse: boolean;
}
export const menuModuleDetailsData: MenuModuleDetail[] = [
    {
        title: "Easy real-time menu updates",
        text: "Changes to dishes, prices, or descriptions are reflected instantly — without the need to print new menus. This saves time and money and helps prevent mistakes.",
        image: menuScreenshot1,
        bgClass: "ellipse-bg-modules-left",
        reverse: true,
    },
    {
        title: "Savings on printing and operational costs",
        text: "There’s no need to constantly print paper menus or replace worn-out ones — reducing costs for materials and staff time.",
        image: menuScreenshot2,
        bgClass: "ellipse-bg-modules-right",
        reverse: false,
    },
    {
        title: "Increased revenue through marketing",
        text: "You can promote special offers and recommend popular dishes. This helps increase the average check.",
        image: menuScreenshot3,
        bgClass: "ellipse-bg-modules-left",
        reverse: true,
    },
    {
        title: "Fast and convenient access",
        text: "The menu opens instantly after scanning the QR code — without waiting for a waiter.",
        image: menuScreenshot4,
        bgClass: "ellipse-bg-modules-right",
        reverse: false,
    },
    {
        title: "Support for multiple languages",
        text: "A QR menu easily supports multiple languages, making it convenient for tourists and international guests.",
        image: menuScreenshot5,
        bgClass: "ellipse-bg-modules-left",
        reverse: true,
    },
    {
        title: "Convenient for guests",
        items: [
            {
                text: "Access via QR code in seconds;",
            },
            {
                text: "Up-to-date prices and availability;",
            },
            {
                text: "Photos and detailed descriptions;",
            },
            {
                text: "Contactless format.",
            },
        ],
        image: menuScreenshot6,
        bgClass: "ellipse-bg-modules-right",
        reverse: false,
    },
];
